import script from "./AdProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdProductTable.vue?vue&type=script&setup=true&lang=js"

import "./AdProductTable.vue?vue&type=style&index=0&id=198887c5&lang=scss"

const __exports__ = script;

export default __exports__